import styled from "styled-components";

import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton } from "@similarweb/ui-components";

import { INDUSTRY_TAXONOMY_DEMO_ID } from "app/pages/sales-intelligence/modules/industry/constants";
import leadsSearchFiltersI18nKeys from "app/pages/sales-intelligence/modules/leads-search-filters/utils/i18n";
import demoModeTrackingService from "app/pages/sales-intelligence/services/tracking/demo-mode/trackingService";
import { useActiveDemoId, useDemoModeStore } from "app/pages/sales-intelligence/store/demo-mode/useDemoModeStore";

const CenteredReturnButton = styled(IconButton)`
    align-self: center;
`;

/**
 * Exits the industry-taxonomy demo back to the legacy filter. Couples the exit action with its UI.
 */
export const IndustryTaxonomyDemoReturnButton = () => {
    const { translate } = useTranslate();

    const exitDemo = useDemoModeStore((state) => state.exitDemo);
    const demoId = useActiveDemoId();

    if (demoId !== INDUSTRY_TAXONOMY_DEMO_ID) {
        return null;
    }

    const handleReturn = () => {
        demoModeTrackingService.trackDemoReturnClick(demoId);
        exitDemo();
    };

    return (
        <CenteredReturnButton
            data-automation="industry-taxonomy-filter-return-to-legacy"
            type="flat"
            iconName="refresh"
            onClick={handleReturn}
        >
            {translate(leadsSearchFiltersI18nKeys.industryTaxonomyReturnToLegacy())}
        </CenteredReturnButton>
    );
};
